// extracted by mini-css-extract-plugin
export var card = "SimpleSignPostCarouselCard-module--card--a13f9";
export var cardimg = "SimpleSignPostCarouselCard-module--cardimg--12029";
export var cardwrapper = "SimpleSignPostCarouselCard-module--cardwrapper--dcd99";
export var customborderprovider = "SimpleSignPostCarouselCard-module--customborderprovider--67cd6";
export var details = "SimpleSignPostCarouselCard-module--details--4bf8a";
export var image = "SimpleSignPostCarouselCard-module--image--939f9";
export var title = "SimpleSignPostCarouselCard-module--title--11563 headings-module--signpostHeadingSmall--e67c4";